export {Tooltip} from './tooltip';



// WEBPACK FOOTER //
// ./components/tooltip/index.js


// WEBPACK FOOTER //
// ui/components/tooltip/index.js